import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function splitText( el ) {
	if ( ! el ) {
		return;
	}

	const nodes = Array.from( el.childNodes );
	el.innerHTML = '';

	nodes.forEach( ( node ) => {
		if ( node.nodeType === Node.TEXT_NODE ) {
			const words = node.textContent.split( /(\s+)/ );

			words.forEach( ( word ) => {
				if ( word.trim().length === 0 ) {
					el.appendChild( document.createTextNode( word ) );
					return;
				}

				const wordSpan = document.createElement( 'span' );
				wordSpan.className = 'val-word';
				wordSpan.style.display = 'inline-block';
				wordSpan.style.overflow = 'hidden';
				wordSpan.style.verticalAlign = 'bottom';

				for ( const char of word ) {
					const charSpan = document.createElement( 'span' );
					charSpan.className = 'val-letter';
					charSpan.style.display = 'inline-block';
					charSpan.textContent = char;
					wordSpan.appendChild( charSpan );
				}

				el.appendChild( wordSpan );
			} );
		} else if ( node.nodeName === 'BR' ) {
			el.appendChild( document.createElement( 'br' ) );
		} else {
			el.appendChild( node.cloneNode( true ) );
		}
	} );

	el.style.display = 'block';
}

function initWoningaanbodPage() {
	const root = document.querySelector( '[data-page="woningaanbod"]' );

	if ( ! root ) {
		return;
	}

	const breadcrumb = root.querySelector( '.p-woningBreadcrumb' );

	if ( breadcrumb ) {
		gsap.fromTo(
			breadcrumb,
			{ y: 20, opacity: 0 },
			{ y: 0, opacity: 1, duration: 1, ease: 'power3.out', delay: 0.2 }
		);
	}

	const titleElements = root.querySelectorAll( '.reveal-text' );

	titleElements.forEach( ( el ) => {
		splitText( el );

		const letters = el.querySelectorAll( '.val-letter' );
		gsap.set( letters, { yPercent: 110 } );
		gsap.set( el, { opacity: 1 } );

		const isHero = el.closest( '.p-woningHero, .p-rwWonenArchiefHero' );

		gsap.to( letters, {
			yPercent: 0,
			duration: 1.2,
			stagger: 0.02,
			ease: 'power4.out',
			delay: isHero ? 0.4 : 0,
			scrollTrigger: isHero ? null : {
				trigger: el,
				start: 'top 85%',
			},
		} );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initWoningaanbodPage );
} else {
	initWoningaanbodPage();
}
